/*---------------------------------------------------------------------------------------------
* Copyright (c) Bentley Systems, Incorporated. All rights reserved.
* See LICENSE.md in the project root for license terms and full copyright notice.
*--------------------------------------------------------------------------------------------*/
import React, { Fragment, FunctionComponent, ReactNode } from "react";
import { InlineTag } from "../inline-tags/InlineTag";

export interface DescriptionProps extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  description?: string;
  openLinkNewTab?: boolean;
}

export const getHashTags = (description?: string) => {
  if (!description)
    return [];

  const matches: string[] | null = description.match(/@[a-zA-Z]+|#[a-zA-Z]+/gi);
  return matches ?? [];
}

export const Description: FunctionComponent<DescriptionProps> = ({ description: shareDescription, openLinkNewTab, ...props }) => {
  const parseDescription = (description: string) => {
    const parts: ReactNode[] = description.split(/@[a-zA-Z]+|#[a-zA-Z]+/gi);
    const matches: string[] | null = description.match(/@[a-zA-Z]+|#[a-zA-Z]+/gi);
    if (matches) {
      const parsed: ReactNode[] = [];
      for (let i = 0; i < parts.length; i++) {
        parsed.push(parts[i]);
        if (matches[i]) {
          parsed.push(<InlineTag label={matches[i]} key={i} user={matches[i].startsWith("@")} openLinkNewTab={openLinkNewTab} />);
        }
      }
      return <Fragment>{parsed}</Fragment>;
    }
    return description;
  };

  return (
    <div {...props}>
      {shareDescription ? parseDescription(shareDescription) : "No description available."}
    </div>
  );
};
